import { FC, ReactElement } from 'react';
import {
  ConstructionIcon,
  WbBadge,
  WitboostPaletteColor,
} from '@agilelab/plugin-wb-platform';
import { FeatureRequestStatus } from '@agilelab/plugin-wb-builder-common';
import BlockIcon from '@material-ui/icons/Block';
import SendIcon from '@material-ui/icons/Send';
import CheckIcon from '@material-ui/icons/Check';
import DoneAllIcon from '@material-ui/icons/DoneAll';

const STATUS_CONFIG: Record<
  FeatureRequestStatus,
  {
    color?: WitboostPaletteColor;
    icon: ReactElement;
    submitted?: boolean;
    approved?: boolean;
    implemented?: boolean;
    rejected?: boolean;
  }
> = {
  [FeatureRequestStatus.SUBMITTED]: {
    submitted: true,
    icon: <SendIcon fontSize="small" />,
    color: 'secondary',
  },
  [FeatureRequestStatus.APPROVED]: {
    approved: true,
    icon: <CheckIcon fontSize="small" />,
    color: 'success',
  },
  [FeatureRequestStatus.IN_PROGRESS]: {
    color: 'accent',
    icon: <ConstructionIcon fontSize="small" />,
  },
  [FeatureRequestStatus.IMPLEMENTED]: {
    implemented: true,
    icon: <DoneAllIcon fontSize="small" />,
    color: 'primary',
  },
  [FeatureRequestStatus.REJECTED]: {
    rejected: true,
    icon: <BlockIcon fontSize="small" />,
    color: 'error',
  },
};

export const FeatureRequestStatusBadge: FC<{
  status: FeatureRequestStatus;
}> = ({ status }) => {
  const config = STATUS_CONFIG[status];

  return (
    <WbBadge color={config.color} startIcon={config.icon}>
      {status.replace('_', ' ')}
    </WbBadge>
  );
};
